import AddPhoneNumber from 'actions/customer_profile/add_phone_number';
import connect from 'components/lib/connect';
import CreateEmailComposition from 'actions/composition/create_email_composition';
import CreatePhoneCallComposition from 'actions/composition/create_phone_call_composition';
import InlineAnnotatedContent from './inline_annotated_content';
import { isVoiceEnabled } from 'components/lib/voice/is_voice_enabled';
import { getLatestConversation } from 'models/customer';
import UpdateEmailAddress from 'actions/customer_profile/update_email_address';

export const InlineAnnotatedContentActionsConnector = connect(
  mapActionStateToProps,
  mapExecuteToProps
)(InlineAnnotatedContent);

function mapActionStateToProps(context, props) {
  return props;
}

function mapExecuteToProps(executeAction, { conversationId, profile }) {
  return {
    onCallPhone: phoneNumber => executeAction(CreatePhoneCallComposition, { phoneNumber, conversationId }),
    onSavePhone: phoneNumber => addPhoneNumber(phoneNumber),

    onSendEmail: email => executeAction(CreateEmailComposition, { conversationId, toAddress: email }),
    onSaveEmail: email => addEmail(email),
  };

  function addPhoneNumber(phoneNumber) {
    if (profile && !profile.hasPhoneNumber(phoneNumber)) {
      executeAction(AddPhoneNumber, { phoneNumber, primary: true });
    }
  }

  function addEmail(email) {
    if (profile && !profile.hasEmail(email)) {
      executeAction(UpdateEmailAddress, { original: email, index: profile.emails.length });
    }
  }
}

export default connect(mapStateToProps)(InlineAnnotatedContentActionsConnector);

function mapStateToProps(context, props) {
  let conversation = getLatestConversation(context.getProvider('conversations').findAll());
  const channelConfiguration = context.getProvider('channelConfiguration').get();

  return {
    ...props,
    canEmail: channelConfiguration && channelConfiguration.fromAddresses().length > 0,
    conversationId: conversation && conversation.id,
    hasVoice: isVoiceEnabled(context), // cannot make outbound calls with CTI integration
    profile: context.getProvider('profile').get(),
    profileHasErrors: context.getProvider('profile').getErrors().length > 0,
    hasExternalAgentActions: context.isFeatureEnabled('externalAgentActions'),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/inline_annotated_content_container.jsx